// Generated from HCPGrammarParser.g4 by ANTLR 4.7.1
// jshint ignore: start
var antlr4 = require('./antlr4/index');

// This class defines a complete generic visitor for a parse tree produced by HCPGrammarParser.

function HCPGrammarParserVisitor() {
	antlr4.tree.ParseTreeVisitor.call(this);
	return this;
}

HCPGrammarParserVisitor.prototype = Object.create(antlr4.tree.ParseTreeVisitor.prototype);
HCPGrammarParserVisitor.prototype.constructor = HCPGrammarParserVisitor;

// Visit a parse tree produced by HCPGrammarParser#program.
HCPGrammarParserVisitor.prototype.visitProgram = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#sourceElement.
HCPGrammarParserVisitor.prototype.visitSourceElement = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#statement.
HCPGrammarParserVisitor.prototype.visitStatement = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#statementList.
HCPGrammarParserVisitor.prototype.visitStatementList = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#variableStatement.
HCPGrammarParserVisitor.prototype.visitVariableStatement = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#ctypeStatement.
HCPGrammarParserVisitor.prototype.visitCtypeStatement = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#variableDeclarationList.
HCPGrammarParserVisitor.prototype.visitVariableDeclarationList = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#ScalarVariableDeclaration.
HCPGrammarParserVisitor.prototype.visitScalarVariableDeclaration = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#ArrayVariableDeclaration.
HCPGrammarParserVisitor.prototype.visitArrayVariableDeclaration = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#emptyStatement.
HCPGrammarParserVisitor.prototype.visitEmptyStatement = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#expressionStatement.
HCPGrammarParserVisitor.prototype.visitExpressionStatement = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#ifStatement.
HCPGrammarParserVisitor.prototype.visitIfStatement = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#vartype.
HCPGrammarParserVisitor.prototype.visitVartype = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#sourceElements.
HCPGrammarParserVisitor.prototype.visitSourceElements = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#expressionSequence.
HCPGrammarParserVisitor.prototype.visitExpressionSequence = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#ParenthesizedExpression.
HCPGrammarParserVisitor.prototype.visitParenthesizedExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#AdditiveExpression.
HCPGrammarParserVisitor.prototype.visitAdditiveExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#RelationalExpression.
HCPGrammarParserVisitor.prototype.visitRelationalExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#ArrowPropExpression.
HCPGrammarParserVisitor.prototype.visitArrowPropExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#LogicalAndExpression.
HCPGrammarParserVisitor.prototype.visitLogicalAndExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#LiteralExpression.
HCPGrammarParserVisitor.prototype.visitLiteralExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#LogicalOrExpression.
HCPGrammarParserVisitor.prototype.visitLogicalOrExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#customFnExpression.
HCPGrammarParserVisitor.prototype.visitCustomFnExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#NotExpression.
HCPGrammarParserVisitor.prototype.visitNotExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#MemberIndexExpression.
HCPGrammarParserVisitor.prototype.visitMemberIndexExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#builtInTimeExpression.
HCPGrammarParserVisitor.prototype.visitBuiltInTimeExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#AssetConnectionExpression.
HCPGrammarParserVisitor.prototype.visitAssetConnectionExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#UnaryMinusExpression.
HCPGrammarParserVisitor.prototype.visitUnaryMinusExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#AssignmentExpression.
HCPGrammarParserVisitor.prototype.visitAssignmentExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#BitAndExpression.
HCPGrammarParserVisitor.prototype.visitBitAndExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#IdentifierRightExpression.
HCPGrammarParserVisitor.prototype.visitIdentifierRightExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#BitOrExpression.
HCPGrammarParserVisitor.prototype.visitBitOrExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#UnaryPlusExpression.
HCPGrammarParserVisitor.prototype.visitUnaryPlusExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#builtInFnExpression.
HCPGrammarParserVisitor.prototype.visitBuiltInFnExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#EqualityExpression.
HCPGrammarParserVisitor.prototype.visitEqualityExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#BitXOrExpression.
HCPGrammarParserVisitor.prototype.visitBitXOrExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#MultiplicativeExpression.
HCPGrammarParserVisitor.prototype.visitMultiplicativeExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#BitShiftExpression.
HCPGrammarParserVisitor.prototype.visitBitShiftExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#IdentifierNameIndexedArray.
HCPGrammarParserVisitor.prototype.visitIdentifierNameIndexedArray = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#IdentifierNameEmptyArray.
HCPGrammarParserVisitor.prototype.visitIdentifierNameEmptyArray = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#IdentifierNameOnly.
HCPGrammarParserVisitor.prototype.visitIdentifierNameOnly = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#identifierSetProps.
HCPGrammarParserVisitor.prototype.visitIdentifierSetProps = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#identifierGetProps.
HCPGrammarParserVisitor.prototype.visitIdentifierGetProps = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#builtInfunction.
HCPGrammarParserVisitor.prototype.visitBuiltInfunction = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#CustomFunctionArgumentsExpression.
HCPGrammarParserVisitor.prototype.visitCustomFunctionArgumentsExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#CustomFunctionNamedArgumentExpression.
HCPGrammarParserVisitor.prototype.visitCustomFunctionNamedArgumentExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#timeExpression.
HCPGrammarParserVisitor.prototype.visitTimeExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#timeExpressionOperator.
HCPGrammarParserVisitor.prototype.visitTimeExpressionOperator = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#arrowExpression.
HCPGrammarParserVisitor.prototype.visitArrowExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#StringLiteralExpression.
HCPGrammarParserVisitor.prototype.visitStringLiteralExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#NumericLiteralExpression.
HCPGrammarParserVisitor.prototype.visitNumericLiteralExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#timePeriod.
HCPGrammarParserVisitor.prototype.visitTimePeriod = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#timeConstantColonExpression.
HCPGrammarParserVisitor.prototype.visitTimeConstantColonExpression = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#timeConstantColonExpression2.
HCPGrammarParserVisitor.prototype.visitTimeConstantColonExpression2 = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#timeConstantLiteral.
HCPGrammarParserVisitor.prototype.visitTimeConstantLiteral = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#numericLiteral.
HCPGrammarParserVisitor.prototype.visitNumericLiteral = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#identifierName.
HCPGrammarParserVisitor.prototype.visitIdentifierName = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#reservedWord.
HCPGrammarParserVisitor.prototype.visitReservedWord = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#keyword.
HCPGrammarParserVisitor.prototype.visitKeyword = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#eos.
HCPGrammarParserVisitor.prototype.visitEos = function(ctx) {
  return this.visitChildren(ctx);
};


// Visit a parse tree produced by HCPGrammarParser#eos2.
HCPGrammarParserVisitor.prototype.visitEos2 = function(ctx) {
  return this.visitChildren(ctx);
};



exports.HCPGrammarParserVisitor = HCPGrammarParserVisitor;